import { cn } from '../../lib/utils';
import type { ResizeHandleProps } from '../../lib/resizable';

/**
 * Drag handle between a side panel and the pane beside it.
 *
 * Rendered wider than it looks: a 1px visual line is miserable to grab, so the hit area is 5px
 * with the highlight drawn inside it. `touch-none` stops a drag from being stolen by the
 * browser's scroll gesture on trackpads and touch screens.
 */
export function ResizeHandle({
  handleProps, onDoubleClick, className,
}: {
  handleProps: ResizeHandleProps;
  /** Usually a reset-to-default-width. */
  onDoubleClick?: () => void;
  className?: string;
}) {
  return (
    <div
      {...handleProps}
      onDoubleClick={onDoubleClick}
      role="separator"
      aria-orientation="vertical"
      title="Drag to resize · double-click to reset"
      className={cn(
        'group relative w-[5px] flex-shrink-0 cursor-col-resize touch-none select-none',
        className,
      )}
    >
      <span className="absolute inset-y-0 left-1/2 -translate-x-1/2 w-px bg-transparent group-hover:bg-orange-300 group-active:bg-orange-400 transition-colors" />
    </div>
  );
}
